import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// Containers
import Full from '@/containers/Full'
import Admin from '@/views/admin/'
import Home from '@/views/Home'

// Views
import Auth from '@/views/auth/'
import Management from '@/views/management/'

import Unavailable from '@/views/Unavailable.vue'
import Page404 from '@/views/Page404.vue'
import TestPage from '@/views/TestPage.vue'

import Store from '@/store'
const state = Store.state

import RedirectComponent from '@/views/Redirect.vue'

let router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ }),
  routes: [
    {
      path: '/auth',
      name: 'Auth',
      redirect: '/auth/log-in',
      component: { render: c => c('router-view') },
      children: [
        {
          path: 'log-in',
          name: 'Login',
          component: Auth.Login,
          meta: { authed: false}
        },
        {
          path: 'sign-up',
          name: 'SignUp',
          component: Auth.SignUp,
          meta: { authed: false}
        },
        {
          path: 'forgot-password',
          name: 'ForgotPassword',
          component: Auth.ForgotPassword,
          meta: { authed: false}
        },
        {
          path: 'resetlink/:token',
          name: 'ResetLink',
          component: Auth.ResetLink
        }
      ]
    },
    {
      path: '/',
      meta: {
        authed: true,
        skip: true
      },
      component: Full,
      redirect: {name: 'Home'},
      children: [
        {
          path: 'home',
          name: 'Home',
          component: Home
        },
        {
          path: 'admin',
          name: 'Admin',
          meta: {
            permission: "users"
          },
          component: { render: c => c('router-view') },
          children: [
            {
              path: 'edit-user',
              name: 'AdminEditUser',
              component: Admin.EditUser
            },
            {
              path: 'edit-roles',
              name: 'AdminEditRoles',
              component: Admin.EditRoles
            },
            {
              path: 'edit-permissions',
              name: 'AdminEditPermissions',
              component: Admin.EditPermissions
            }
          ]
        },
        {
          name: 'Management',
          path: '/man',
          component: { render: c => c('router-view') },
          meta: {
            skip: true
          },
          children: [
            {
              path: "campaigns",
              name: "ManCampaigns",
              component: Management.Campaigns,
            }
          ]
        }
      ]
    },
    {
      path: '/test',
      component: TestPage
    },
    {
      name: 'Unavailable',
      path: '/unavailable',
      component: Unavailable,
      beforeEnter: (to, from, next) => {
        if(state.version !== 'ERROR') {
          next('/')
        } else {
          next(true)
        }
      }
    },
    {
      path: '*',
      component: Page404
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(state.version !== null) {
    return next(true)
  }
  Vue.http.get('version')
    .then(r => r.json())
    .then(r => r.data)
    .then(data => {
      state.version = data
      next(true)
    })
    .catch(err => {
      state.version = 'ERROR'
      next({name: 'Unavailable' })
    })
})

router.beforeEach((to, from, next) => {
  if(state.user !== null) {
    return next(true)
  }
  Vue.http.get('auth')
    .then(r => r.json())
    .then(data => {
      state.user = data.user
      if(data.token) {
        localStorage.setItem('token', data.token)
        window.setCookie('token', data.token, 365*10)
      }
    })
    .catch(err => {
      state.user = false
    })
    .then(() => {
      state.initialLoad = true
      next(true)
    })
})
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => typeof record.meta.authed !== "undefined" && record.meta.authed !== !!state.user)) {
      return next({name: !!state.user ? 'Home' : 'Login'})
  }
  next(true)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js